import { View } from "react-native";

import { Button } from "../../src/components/rnr/button";
import { Text } from "../../src/components/rnr/text";

export default function ReactNativeReusablesSmokeScreen() {
  return (
    <View className="flex-1 items-center justify-center bg-background p-6">
      <View className="w-full max-w-md gap-5 rounded-lg border border-border bg-card p-6">
        <View className="gap-2">
          <Text
            variant="h1"
            className="text-left font-display text-3xl text-card-foreground"
          >
            React Native Reusables Ready
          </Text>
          <Text className="font-manrope text-muted-foreground">
            Monarch tokens are now available to source-owned universal components.
          </Text>
        </View>

        <View className="flex-row gap-3">
          <Button className="min-h-11 flex-1" accessibilityLabel="Primary test action">
            <Text className="font-manrope-semibold">Primary Action</Text>
          </Button>
          <Button
            variant="outline"
            className="min-h-11 flex-1"
            accessibilityLabel="Secondary test action"
          >
            <Text className="font-manrope-semibold">Secondary</Text>
          </Button>
        </View>
      </View>
    </View>
  );
}
